import * as Utils from 'Assets/Utils'
import { isLoading } from 'Modules/Loading'
import { createModal } from 'Modules/Modal'
import ClientHttpRequest from "Api/ClientHttpRequest"
import Immutable from 'immutable'

const initialState = Immutable.Map({}).set('Search', new Immutable.List([])).set('Response', new Immutable.Map({})).set('Get', new Immutable.Map({}))

/* Types */
export const GET_ITEMS = 'GET_ITEMS'
export const GET_DONOR = 'GET_DONOR'

/* Reducer */
export default (state = initialState, action) => {

	switch (action.type) {
		case GET_ITEMS:
			return state.set('Get', new Immutable.Map(action.Obj))
		case GET_DONOR:
			return state.set('Search', new Immutable.Map(action.Obj))
		default:
			return state;
	}
};

/* Action Creators */

export const getItems = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/getItems',
			method: "POST",
			data: {...form },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false));

			let newRubros = []

			if (response.data.rubrosSolicitud) {
				response.data.rubrosSolicitud.rubros.rubro.forEach((r) => {
					r = {...r, id: Utils.getUUID(), tmp: 'tmp', idTipoGasto: r.tipoGasto.id}
					newRubros.push(r)
				})
			}

			let formItems = {
				costoTotalProyecto: response.data.rubrosSolicitud ? response.data.rubrosSolicitud.costoTotalProyecto : '',
				montoMaximoSolicitar: response.data.rubrosSolicitud ? response.data.rubrosSolicitud.montoMaximoSolicitar : '',
				donativoPre: response.data.rubrosSolicitud ? response.data.rubrosSolicitud.donativoPre : '',
				fuentes: response.data.rubrosSolicitud ? response.data.rubrosSolicitud.fuentesFinanciamiento : '',
				rubros: newRubros
			}

			formItems.uniqueId = Utils.getUUID()
			dispatch({type: GET_ITEMS, Obj: formItems})
			return formItems
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const addItems = (form) => {

	let temp = {...form}
	temp.rubros = Utils.getListPropsOmit(temp.rubros, ['id', 'tmp', 'idTipoGasto'])

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/addItems',
			method: "POST",
			data: {...temp },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false));
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const getDonor = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/getItemDonors',
			method: "POST",
			data: {...form },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false));

			const data = Object.assign({}, response.data)
			let expenseType = []

			if (data.rubrosSolicitud.rubros) {
				data.rubrosSolicitud.rubros.rubro.forEach((r) => {
					expenseType.push({
						id: r.idRubro,
						valor: r.concepto
					})
				})
			}

			if (data.donantes) {
				data.donantes.uniqueId = Utils.getUUID()
			}

			dispatch({ type: GET_DONOR, Obj: { donors: data.donantes ? data.donantes.donante : [], expenseType: expenseType } })
			return data.donantes ? data.donantes.donante : [];
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const clearItems = () => {

	return (dispatch) => {
		dispatch({ type: GET_DONOR, Obj: {} })
		dispatch({ type: GET_ITEMS, Obj: {} })
		return Promise.resolve()
	}
}



// WEBPACK FOOTER //
// ./src/modules/Grantees/Opportunities/Items.js